import { useCallback, useMemo } from 'react'

import { getFormattedDateByLanguage, getFormatted12HourTime } from 'utils/formatDate'

import type { TUploadListItemModel } from './upload-list-item.types'
import { bytesToMb, getFileTypeFromExtension } from '../common/documents.utils'

export const useUploadListItemModel: TUploadListItemModel = ({
  fileExtension,
  fileSize,
  uploadDate,
  documentId,
  onDelete,
  language,
}) => {
  const fileType = useMemo(() => getFileTypeFromExtension(fileExtension), [fileExtension])

  const formattedFileSize = useMemo(() => `${bytesToMb(fileSize)}mb`, [fileSize])

  const formattedDateTime = useMemo(() => {
    const formattedDate = getFormattedDateByLanguage(uploadDate, language)
    const formattedTime = getFormatted12HourTime(uploadDate)
    return `${formattedDate}, ${formattedTime}`
  }, [uploadDate, language])

  const handleDelete = useCallback(() => {
    onDelete(documentId)
  }, [documentId, onDelete])

  return {
    fileType,
    formattedFileSize,
    formattedDateTime,
    handleDelete,
  }
}
